import { render, staticRenderFns } from "./CompetitorSearch.vue?vue&type=template&id=5c812be0&"
import script from "./CompetitorSearch.vue?vue&type=script&lang=js&"
export * from "./CompetitorSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports